import { render, staticRenderFns } from "./template-work-order-build-form.html?vue&type=template&id=5c1d6edf&scoped=true&"
import script from "./template-work-order-build-form.ts?vue&type=script&lang=js&"
export * from "./template-work-order-build-form.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1d6edf",
  null
  
)

export default component.exports